/* eslint-disable prettier/prettier */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ObjetivoEstrategico } from 'src/app/shared/models/objetivo-estrategico.model';
import { environment } from 'src/environments/environment';
import { ObjetivosEstrategicos } from './objetivos.enum';
import { NavigationService } from '../services/navigation.service';
import { MapaService } from 'src/app/shared/services/mapa.service';

@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.scss'],
})
export class MapaComponent extends BaseFormComponent<ObjetivoEstrategico[]> implements OnInit {
  imagePath: string =
    environment.clientUrl + '/assets/images/mapa-estrategico/';

  items_map: any[] = [
    {
      label: 'Mapa Estratégico',
      value: 'M1',
    },
    {
      label: 'Mapa Estratégico - Contribuição da minha secretária',
      value: 'M2',
    },
  ];

  objetivoValido: ObjetivoEstrategico[];
  projects: string = "M1";
  lista1: ObjetivoEstrategico[];
  objs: any = {}; // Objeto para armazenar os enums
  map_id: any;

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private mapaService: MapaService,
    private navigation: NavigationService,
  ) {
    super(activatedRoute)
  }

  ngOnInit() {
    this.loading();
    this.objs = ObjetivosEstrategicos;
    this.addSub(
      this.mapaService.index().subscribe({
        next: (res) => {
          this.objetivoValido = res['list'];
          this.map_id = res['map_id'];
          this.loaded();
        },
      })
    );
  }

  verificaObjetivo(search) {
    return this.objetivoValido
      .some((objeto) =>
        objeto.str_nome.includes(search)
      );
  }

  filterAgency(e) {
    this.projects = e?.value;
  }

  linkMap(event, link) {
    event.preventDefault();

    if (this.map_id[link]) {
      this.router.navigate(['projetos', 'projeto'], { queryParams: { filter_objective: this.map_id[link] } })
    } else {
      this.msgError('Nenhum projeto relacionado a esse Objetivo Estratégico.', 'Alerta');
    }
  }
}
